module.exports = __webpack_public_path__ + "static/media/bannerRecomenda.1d7eb0ca.jpg";